import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import styled from 'styled-components';
export var HorizontalMenu = styled(_Menu).withConfig({
  displayName: "styles__HorizontalMenu",
  componentId: "sc-ef5v6o-0"
})(["background:#212529;min-width:700px;"]);